export const blogData = [
  {
    id: 1,
    title: 'The Truth About Cho-lesterol and Your Heart -From a Doctors Desk',
    excerpt: 'We often hear that cholesterol is "bad for the heart." Many patients who come to me are scared the moment they see the word cholesterol on their lab reports...',
    author: 'Dr. Abhijeet Tiwade',
    date: '2025-11-01',
    readTime: '5 min read',
    externalLink: 'https://medium.com/@abhijeettiwade2/the-truth-about-cholesterol-and-your-heart-from-a-doctors-desk-f2ab6aa683f0'
  },
];